 var swiper = new Swiper(".mySwiper.slider_slide", {
       loop:false,
        pagination: {
          el: ".swiper-pagination",
          clickable:true,
        },
        speed:500,
        pauseOnMouseEnter: true,
        breakpoints: {
          0: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 500,
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          }
        },
    });